// extracted by mini-css-extract-plugin
export var searchHeader = "_41-0";
export var searchHeaderDark = "_41-1";